import { render, staticRenderFns } from "./ProjectTotals.vue?vue&type=template&id=5173c58c"
import script from "./ProjectTotals.vue?vue&type=script&lang=js"
export * from "./ProjectTotals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports